import type { ActionsBarProps } from "./actions-bar.type";

import { MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, Flex } from "antd";
import { Fragment } from "react";

import "./actions-bar.style.less";
import {
  getActionsBarPrimaryItems,
  getActionsBarSecondaryItems,
} from "./actions-bar.helper";

export const ActionsBar = ({
  primaryActions,
  secondaryActions,
}: ActionsBarProps) => {
  const primary = getActionsBarPrimaryItems(primaryActions);
  const hasPrimary = primary.length > 0;

  const secondary = getActionsBarSecondaryItems(secondaryActions);
  const hasSecondary = secondary.length > 0;

  if (!hasPrimary && !hasSecondary) return null;

  return (
    <Flex className="actions-bar">
      {primary.map((action) => (
        <Fragment key={action.key}>{action.node}</Fragment>
      ))}
      {hasSecondary && (
        <Dropdown
          menu={{ items: secondary }}
          trigger={["click"]}
          classNames={{
            root: "actions-bar-dropdown",
            item: "actions-bar-dropdown--item",
          }}
        >
          <Button icon={<MoreOutlined />} />
        </Dropdown>
      )}
    </Flex>
  );
};
